/* eslint-disable no-bitwise */
import * as React from "react";
import { getActiveMapVariant, getUnitSize } from "../../../map/variants";
import BuildUnit from "../../../enums/BuildUnit";
import Country from "../../../enums/Country";
import UIState from "../../../enums/UIState";
import WDArmyIcon from "../../ui/units/WDArmyIcon";
import WDFleetIcon from "../../ui/units/WDFleetIcon";

export interface BuildData {
  availableOrder: string;
  clickCallback: (
    availableOrder: BuildData["availableOrder"],
    canBuild: BuildData["canBuild"],
    toTerrID: BuildData["toTerrID"],
  ) => void;
  country: Country;
  canBuild: BuildUnit;
  province: string;
  unitSlotName: string;
  toTerrID: string;
}

const WDBuildUnitButtons: React.FC<BuildData> = function ({
  availableOrder,
  clickCallback,
  country,
  canBuild,
  province,
  unitSlotName,
  toTerrID,
}): React.ReactElement {
  const { provincesMapData } = getActiveMapVariant();
  const provinceMapData = provincesMapData[province];
  let svgX =
    provinceMapData.x + provinceMapData.unitSlotsBySlotName[unitSlotName].x;
  let svgY =
    provinceMapData.y + provinceMapData.unitSlotsBySlotName[unitSlotName].y;

  // 尺寸跟随棋子的 unitSize：建造按钮与棋子体量相当，任何地图都适用
  const unitSize = getUnitSize();
  const rh = Math.round(unitSize * 0.95);
  let rw = rh;
  const rBorder = Math.round(unitSize * 0.13);
  const rFill = "rgba(0,0,0,.7)";
  const buildButtons: React.ReactElement[] = [];
  /*
   * 图标原始坐标系是 50×50（见 WDArmyIcon / WDFleetIcon 的 RAW_ICON_*），
   * 之前用 <svg style={{width,height}}> 包一层并不会缩放内部图形 ——
   * 图标仍按 50×50 画，结果比白色圆点大一圈、两个按钮互相压住。
   * 这里显式按 scale 缩放到 iconSize。
   */
  const iconSize = Math.round(unitSize * 0.66);
  const iconScale = iconSize / 50;
  const groupStyle: React.CSSProperties = {
    cursor: "pointer",
  };

  const cx = 0 + rw / 2;
  const cy = 0 + rh / 2;
  const r = Math.round(unitSize * 0.33);
  const iconX = cx - r;
  const iconY = cy - r;
  svgY -= rh;
  if (canBuild & BuildUnit.Army) {
    buildButtons.push(
      <g
        key="Army"
        style={groupStyle}
        onClick={() => {
          clickCallback(availableOrder, BuildUnit.Army, toTerrID);
        }}
      >
        <circle fill="white" r={r} cx={cx} cy={cy} />
        <g transform={`translate(${iconX} ${iconY}) scale(${iconScale})`}>
          <WDArmyIcon country={country} iconState={UIState.BUILD} />
        </g>
      </g>,
    );
  }
  if (canBuild & BuildUnit.Fleet) {
    let shift = 0;
    if (buildButtons.length) {
      shift = rw - rBorder;
      rw = rw * 2 - rBorder;
    }
    buildButtons.push(
      <g
        key="Fleet"
        style={groupStyle}
        onClick={() => {
          clickCallback(availableOrder, BuildUnit.Fleet, toTerrID);
        }}
      >
        <circle fill="white" r={r} cx={cx + shift} cy={cy} />
        <g
          transform={`translate(${iconX + shift} ${iconY}) scale(${iconScale})`}
        >
          <WDFleetIcon country={country} iconState={UIState.BUILD} />
        </g>
      </g>,
    );
  }
  svgX -= rw / 2;
  return (
    <svg x={svgX} y={svgY}>
      <rect
        x={0}
        y={0}
        fill={rFill}
        width={rw}
        height={rh}
        rx={rBorder}
        ry={rBorder}
      />
      {buildButtons}
    </svg>
  );
};

export default WDBuildUnitButtons;
